function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "google-drive-orig");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.1,1.21428571 C2.91428571,1.21428571 1.21428571,2.91428571 1.21428571,5.1 C1.21428571,7.2047619 2.91428571,8.98571429 5.1,8.98571429 C7.28571429,8.98571429 8.98571429,7.28571429 8.98571429,5.1 C8.9047619,2.91428571 7.2047619,1.21428571 5.1,1.21428571 Z M7.52857143,5.42380952 L5.42380952,5.42380952 L5.42380952,7.52857143 C5.42380952,7.69047619 5.26190476,7.85238095 5.1,7.85238095 C4.93809524,7.85238095 4.77619048,7.69047619 4.77619048,7.52857143 L4.77619048,5.42380952 L2.67142857,5.42380952 C2.50952381,5.42380952 2.34761905,5.26190476 2.34761905,5.1 C2.34761905,4.93809524 2.50952381,4.77619048 2.67142857,4.77619048 L4.77619048,4.77619048 L4.77619048,2.59047619 C4.77619048,2.42857143 4.93809524,2.26666667 5.1,2.26666667 C5.26190476,2.26666667 5.42380952,2.42857143 5.42380952,2.59047619 L5.42380952,4.6952381 L7.52857143,4.6952381 C7.69047619,4.6952381 7.85238095,4.85714286 7.85238095,5.01904762 C7.85238095,5.26190476 7.69047619,5.42380952 7.52857143,5.42380952 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-98.000000, -242.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "google-drive-orig",
  transform: "translate(98.000000, 242.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  x: 0,
  y: 0,
  width: 13.6524355,
  height: 12.1980519
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.03214286,10.4543561 L1.63422619,11.4943182 C1.75933442,11.7132576 1.93917749,11.8852814 2.15029762,12.0103896 L4.30059524,8.28841991 L0,8.28841991 C0,8.5308171 0.0625541126,8.77321429 0.187662338,8.99215368 L1.03214286,10.4543561 Z",
  id: "svg_1",
  fill: "#554C58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.82621753,3.90963203 L4.67591991,0.187662338 C4.46479978,0.312770563 4.28495671,0.484794372 4.15984848,0.703733766 L0.187662338,7.58468615 C0.0648550091,7.79890396 0.000163510654,8.04149708 0,8.28841991 L4.30059524,8.28841991 L6.82621753,3.90963203 Z",
  id: "svg_2",
  fill: "#786C7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5021374,12.0103896 C11.7132576,11.8852814 11.8931006,11.7132576 12.0182089,11.4943182 L12.2684253,11.0642587 L13.4647727,8.99215368 C13.589881,8.77321429 13.6524351,8.5308171 13.6524351,8.28841991 L9.35152706,8.28841991 L10.2666937,10.0868506 L11.5021374,12.0103896 Z",
  id: "svg_3",
  fill: "#554C58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.82621753,3.90963203 L8.97651515,0.187662338 C8.76539502,0.0625541126 8.52299784,0 8.27278139,0 L5.37965368,0 C5.12943723,0 4.88704004,0.0703733766 4.67591991,0.187662338 L6.82621753,3.90963203 Z",
  id: "svg_4",
  fill: "#554C58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.35183983,8.28841991 L4.30059524,8.28841991 L2.15029762,12.0103896 C2.36141775,12.1354978 2.60381494,12.1980519 2.85403139,12.1980519 L10.7984037,12.1980519 C11.0486201,12.1980519 11.2910173,12.1276786 11.5021374,12.0103896 L9.35183983,8.28841991 Z",
  id: "svg_5",
  fill: "#786C7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4786797,4.14420996 L9.49258658,0.703733766 C9.36747835,0.484794372 9.18763528,0.312770563 8.97651515,0.187662338 L6.82621753,3.90963203 L9.35183983,8.28841991 L13.6446158,8.28841991 C13.6446158,8.04602273 13.5820617,7.80362554 13.4569535,7.58468615 L11.4786797,4.14420996 Z",
  id: "svg_6",
  fill: "#786C7C"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(6.476190, 7.285714)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.1,9.16195258 C7.91665222,9.16195258 9.16864655,7.91665222 9.16864655,5.1 C9.16864655,2.28334778 7.91665222,1.15463195e-14 5.1,1.15463195e-14 C2.28334778,1.15463195e-14 1.15463195e-14,2.28334778 1.15463195e-14,5.1 C1.15463195e-14,7.91665222 2.28334778,9.16195258 5.1,9.16195258 Z",
  id: "Oval",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#746B7A",
  xlinkHref: "#path-1"
}))))));

var SvgGoogleDrive = function SvgGoogleDrive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleDrive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-drive.f092aa5d.svg";
export { ForwardRef as ReactComponent };